import React from 'react';
import { TPunishment } from '../../utils/types';
import { NAPageItemConfigType, PageItemRenderingProps } from '../ConfigTypes';
import NotApprovedBadUtterance from '../../components/NotApprovedBadUtterance';
import isPlatformEvidenceVisibleInView from '../../utils/isPlatformEvidenceVisibleInView';

/**
 * This is a special section reserved for badUtterances data
 * This is essentially an ennumeration of each violating items we identified under corresponding category
 */
const BadUtterancesPageItem = (props: PageItemRenderingProps): JSX.Element => {
  const { punishmentData } = props;
  return (
    <div data-testid='bad-utterances' className='not-approved-punishment-details'>
      {punishmentData.badUtterances.map((badUtterance, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <NotApprovedBadUtterance key={i} badUtterance={badUtterance} />
      ))}
    </div>
  );
};

const BadUtterancesPageItemConfig: NAPageItemConfigType = {
  getIsVisible: (punishmentData: TPunishment) => {
    // Display BadUtterancesPageItemConfig only if we're not displaying ViolationPageItemConfig
    return (
      !isPlatformEvidenceVisibleInView(punishmentData) &&
      !!punishmentData.badUtterances &&
      punishmentData.badUtterances.length > 0 &&
      !punishmentData.verificationCategory
    );
  },
  renderComponent: BadUtterancesPageItem,
  configName: 'bad-utterrances'
};

export default BadUtterancesPageItemConfig;
